import { lazy, Suspense, type ReactNode } from 'react';
import { config } from '../config';
import { DevAuth } from './DevAuth';
import { PantallaCarga } from '../components/Estados';

// MSAL solo se descarga cuando la autenticación es Entra ID.
const EntraAuth = lazy(() => import('./EntraAuth'));

export function AuthRaiz({ children }: { children: ReactNode }) {
  if (config.modoAuth === 'dev') return <DevAuth>{children}</DevAuth>;
  return (
    <Suspense fallback={<PantallaCarga texto="Preparando el inicio de sesión…" />}>
      <EntraAuth>{children}</EntraAuth>
    </Suspense>
  );
}
